import {memo} from "react";

export const memoWithType: <T>(component: T) => T = memo;
